export const ABORT_ERROR = 'AbortError'
export const TIMEOUT = 'Error in fetchWithTimeout:'
export const ASSET_DATA_ERROR = 'Error in processAssetData'
export const ALTERNATIVE_ERROR = 'Error in handleAlternativeAssetFlow:'
export const RATE_LIMIT_EXCEEDED_EXCEPTION = 'RATE_LIMIT_EXCEEDED_EXCEPTION'
export const MAPPING_ALREADY_EXIST = 'MAPPING_ALREADY_EXIST'
export const VERIFY_ERROR = 'Error in verifyOtpSuccess:'
